<template>
  <div class="app-container">
    <!-- <div class="back-button-container">
      <el-button type="primary" icon="el-icon-arrow-left" @click="goBack" size="small">返回上一页</el-button>
    </div> -->
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item label="老师信息：">
              <el-input v-model="query.realName" placeholder="请输入姓名/手机号" clearable size="small" />
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <div class="nav-container">
        <Navs ref="navs" :navList="technicalOption" @changeNav="changeNav" @exportEv="exportEv" :isExport="true" ></Navs>
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column label="老师信息" prop="name" align="center">
            <template slot-scope="{row}">
              <div>
                <span style="display: block;">{{ row.realName }}</span>
                <span style="display: block;">{{ row.mobile }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份" prop="levelName" align="center"></el-table-column>
          <el-table-column label="团队成员" prop="childCount" sortable="custom" align="center" v-if="!isLowLevel">
            <template slot-scope="{row}">
              <span v-if="row.childCount > 0" style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/technology/team',row)">{{ row.childCount }}</span>
              <span v-else>{{ row.childCount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="isServiceTeacher ? '团队大客户人数' : '团队客户人数'" prop="childCustomerCount" sortable="custom" align="center" v-if="!isLowLevel">
            <template slot-scope="{row}">
              <span v-if="row.childCustomerCount > 0" style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/technology/customer',row,1)">{{ row.childCustomerCount }}</span>
              <span v-else>{{ row.childCustomerCount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="isServiceTeacher ? '直属大客户人数' : '客户人数'" prop="customerCount" sortable="custom" align="center">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/technology/customer',row,2)">{{ row.customerCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="签到次数" prop="serviceOrderSignCount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="总业绩" prop="performance" sortable="custom" align="center">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/technology/achievement',row)">{{ row.performance||0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="团队业绩" prop="performanceForChild" sortable="custom" align="center" v-if="!isLowLevel">
            <template slot-scope="{row}">
              <span v-if="row.performanceForChild > 0" style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/technology/achievement',row,1)">{{ row.performanceForChild }}</span>
              <span v-else>{{ row.performanceForChild || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="isServiceTeacher ? '直属大客户业绩' : '客户业绩'" prop="performanceForCustomer" sortable="custom" align="center">
            <template slot-scope="{row}">
              <span v-if="row.performanceForCustomer > 0" style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/technology/achievement',row,2)">{{ row.performanceForCustomer }}</span>
              <span v-else>{{ row.performanceForCustomer || 0 }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="订货量" prop="orderCount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="订货金额" prop="orderPrice" sortable="custom" align="center" width="100">
            <template slot-scope="{row}">
              <span style="display: block;margin-bottom: 2px;">{{ row.orderPrice }}</span>
              <el-button type="primary" size="mini">订货明细</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import Pagination from '@/components/Pagination'
import Times from '../components/times.vue'
import Navs from '../components/navs.vue'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
export default {
    props: {
      isServiceTeacher: {
        type: Number,
        default: 0
      }
    },
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // teamCouSortSign: -1
        // isDisplay: 1,
        // keyword:'',
        // identity:''
      },
      selectItems: [],
      times: null,
      technicalOption: [
        { name: '全部', id: 0 }
      ],
      navIndex: 0,
      today: ''
    }
  },
  computed: {
    // 判断是否为最低等级（3或4）
    isLowLevel() {
      if (this.navIndex === 0) return false // 全部不隐藏
      const currentLevel = this.technicalOption[this.navIndex]
      return currentLevel && (currentLevel.id === 3 || currentLevel.id === 4)
    }
  },
  created() {
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times = {
      timeStart: `${this.today} 00:00:00`,
      timeEnd: `${this.today} 23:59:59`,
    }
    this.doQueryList({ pageNo: 1 })
    this.getOption()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'childCount': 'childCountSortSign',
        'childCustomerCount': this.isServiceTeacher?'childCustomerBigCountSortSign':'childCustomerCountSortSign',
        'customerCount': 'customerCountSortSign',
        'serviceOrderSignCount': 'serverOrderSignInCountSortSign',
        'performance': 'performanceSortSign',
        'performanceForChild': 'performanceForChildSortSign',
        'performanceForCustomer': 'performanceForCustomerSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    getOption() {
      let query = {}
      if(this.isServiceTeacher){
        query.isBigCustomer = true
      } else {
        query.isOrdinary = true
      }
      technicalServiceLevelApi.fetchList(query).then(({data }) => {
        if (data && data.list && Array.isArray(data.list)) {
          let arr = data.list
          this.technicalOption.push(...arr)
        } else {
          console.warn('获取技术等级数据失败或数据格式不正确:', data)
        }
      }).catch(error => {
        console.error('获取技术等级数据失败:', error)
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 获取时间段
     */
    getTime(event) {
      // console.log('event: ',event);
      this.times = JSON.parse(event)
      if (!this.times.ifUse) {
        this.doQueryList({ pageNo: 1 })
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
    handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query = {
        pageNo: 1,
        pageSize: 10,
        // teamCouSortSign: -1
      }
      this.times = {
        timeStart: `${this.today} 00:00:00`,
        timeEnd: `${this.today} 23:59:59`,
      }
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
      this.navIndex = index;
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push("/export/list?code=listForStatisticsDown&isServiceTeacher=" + this.isServiceTeacher)
    },
    /**
     * 执行列表查询
     */
    doQueryList(payload = {}) {
      const { startIndex, pageNo, pageSize } = payload
      const nextPage = startIndex != null ? startIndex : pageNo
      if (nextPage != null) {
        this.query.pageNo = nextPage
      }
      if (pageSize != null) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query, parentId: this.id }
      if (this.navIndex) {
        query.levelId = this.technicalOption[this.navIndex].id
      }
      if (this.times && this.times.timeStart) {
        query.startTime = this.times.timeStart
        query.endTime = this.times.timeEnd
      }
      if(this.isServiceTeacher){
        query.levelIsBigCustomer = true
      } else {
         // query.levelIsOrdinary = true
      }
      this.listLoading = true;
      let Ins = this.isServiceTeacher?technicianInfoApi.getListForStatisticsBig:technicianInfoApi.getListForStatistics
      return Ins(query).then(({ data }) => {
        if (data && data.list) {
          this.list = data.list
          this.total = data.total || 0
        } else {
          this.list = []
          this.total = 0
        }
      }).catch(error => {
        console.error('获取数据失败:', error)
        this.list = []
        this.total = 0
      }).finally(() => {
        this.listLoading = false
      })
    },
    changeSwitch(row) {
      sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 页面跳转
     */
    toPage(path, row, type) {
      if (type) {
        this.$router.push(`${path}?id=${row.id}&index=${type - 1}&isServiceTeacher=${this.isServiceTeacher}`)
      } else {
        this.$router.push(`${path}?id=${row.id}&isServiceTeacher=${this.isServiceTeacher}`)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.back-button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
}

.filter-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 0;
  .times {
    display: flex;
    align-items: center;
  }
  .btns {
    margin-bottom: 22px;
  }
}
</style>
